import angular from 'angular';
import blogSliderComponent from './blog-slider.component';
import blogSliderConfig from './blog-slider.config';

let blogSliderModule = angular.module('app.blogSlider',[])
  .component('blogSlider', blogSliderComponent)
  .config(blogSliderConfig);

export default blogSliderModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/blog/blog-slider/blog-slider.js
 **/